function Home() {
  return <h1>WELCOME TO THE BUDGET APP</h1>;
}

export default Home;
